import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const bgmPlayStore = atom({
  key: "bgmPlayState",
  default: false,
});

export default bgmPlayStore;
